package pl.decks.chartjs.radar.builder

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.model.JSScriptableIndexable
import pl.decks.chartjs.radar.options.PointLabelOptions

@RadarDsl
class PointLabelScope {
    var display: Boolean = true
    private var color: JSScriptableIndexable<ChartColor>? = null
    var padding: Int? = null
    var centerPointLabels: Boolean? = null
    private var fontScope: FontScope? = null

    fun color(value: ChartColor) { color = JSScriptableIndexable.Static(value) }
    fun color(values: List<ChartColor>) { color = JSScriptableIndexable.PerPoint(values) }
    fun color(fn: (dynamic) -> ChartColor) { color = JSScriptableIndexable.Scriptable(fn) }

    fun font(block: FontScope.() -> Unit) {
        fontScope = FontScope().apply(block)
    }

    internal fun build() = PointLabelOptions(
        display = display,
        color = color,
        padding = padding,
        centerPointLabels = centerPointLabels,
        font = fontScope?.build(),
    )
}
